import React from "react";
import {
  CheckboxContainer,
  HiddenCheckbox,
  StyledCheckbox,
  CheckmarkIcon,
  CheckboxLabelContainer,
  Label,
} from "./FormStyles";
import CheckRender from "../Common/CheckRender";
import useEmpresa from "../../hooks/useEmpresa";

const CustomCheckbox = ({
  className,
  checked,
  checkedColor,
  uncheckedColor,
  checkmarkColor,
  label,
  padding,
  ...props
}) => {
  const empresa = useEmpresa();

  return (
    <CheckboxLabelContainer className={className} padding={padding}>
      <CheckboxContainer>
        <HiddenCheckbox checked={checked} {...props} />
        <StyledCheckbox
          checked={checked}
          checkedColor={checkedColor}
          uncheckedColor={uncheckedColor}
        >
          {checked && (
            <CheckmarkIcon viewBox="0 0 24 24" checkmarkColor={checkmarkColor}>
              <polyline points="20 6 9 17 4 12" />
            </CheckmarkIcon>
          )}
        </StyledCheckbox>
      </CheckboxContainer>
      <CheckRender allowed={label}>
        <Label font={empresa?.LETRA_PRINCIPAL} marginBottom="0px">{label}</Label>
      </CheckRender>
    </CheckboxLabelContainer>
  );
};

export default CustomCheckbox;
